import React from 'react';
import '../styles/BookShowcase.css';

const BookShowcase = ({ 
  badge,
  mainTitle,
  bookTitle,
  bookSubtitle,
  description,
  bookImage,
  primaryButtonText,
  primaryButtonLink,
  secondaryButtonText,
  secondaryButtonLink,
  backgroundColor = '#F5F1E8'
}) => {
  return (
    <section className="book-showcase" style={{ backgroundColor }}>
      <div className="container">
        <div className="book-showcase-content">
          {/* Left Side - Book Image */}
          <div className="book-showcase-image-wrapper">
            <div className="book-showcase-image">
              <img src={bookImage} alt={bookTitle} loading="lazy" />
            </div>
          </div>

          {/* Right Side - Text Content */}
          <div className="book-showcase-text">
            {badge && (
              <div className="book-showcase-badge">{badge}</div>
            )}
            <h2 className="book-showcase-main-title">{mainTitle}</h2>
            <div className="book-showcase-book-info">
              <p className="book-showcase-intro">
                {bookSubtitle}
              </p>
            </div>
            <p className="book-showcase-description">{description}</p>

            {/* CTA Buttons */}
            <div className="book-showcase-buttons">
              {primaryButtonText && primaryButtonLink && (
                <a href={primaryButtonLink} className="btn-book-primary">
                  {primaryButtonText}
                </a>
              )}
              {secondaryButtonText && secondaryButtonLink && (
                <a href={secondaryButtonLink} className="btn-book-secondary">
                  {secondaryButtonText}
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookShowcase;

